<script lang="ts">
import Input from "@nextories/vue-core-components/src/components/atoms/input/NxtCoreInput.vue";

export default {
  name: "AdditionalCost",
  nameClassStyle: "additional-cost",
  extends: Input,
  props: {
    field: Object,
    prefix: String,
  },
  data: () => {
    return {
      fields: {
        grandPiano: {
          model: false,
          additionalCost: 400,
        },
        uprightPiano: {
          model: false,
          additionalCost: 250,
        },
        americanFridge: {
          model: false,
          additionalCost: 200,
        },
        secondAddress: {
          model: false,
          additionalCost: 150,
        },
        portageSup: {
          model: false,
          additionalCost: 150,
        },
        scooter: {
          model: false,
          additionalCost: 150,
        },
      },
      model: 0,
    };
  },
  created() {
    if (!Number.isInteger(this.modelValue)) {
      this.model = 0;
    }
  },
  methods: {
    calcTotal(field: { model?: number; additionalCost: number }) {
      if (field.model) {
        this.model += field.additionalCost;
      } else {
        this.model -= field.additionalCost;
      }
      this.model = Math.round(this.model * 100) / 100;
    },
  },
};
</script>

<template>
  <div :class="$setClasses">
    <div class="u-display-flex u-ai-center u-margin-bottom-xsmall">
      <template v-for="[id, checkbox] of Object.entries(fields)" :key="`${id}`">
        <span class="u-display-flex u-margin-right-default">
          <nxt-core-input-checkbox v-model="checkbox.model" @changedValue="calcTotal(checkbox)">
            {{ $t(`estimate.additionalCost.${id}`) }}
          </nxt-core-input-checkbox>
        </span>
      </template>
    </div>
    <nxt-core-input-number v-model="model"
                           :display-buttons="false"
                           :prefix="$t('estimate.additionalCost.total')"
                           :suffix="$t('base.currency')"
                           class="--prepend-append"
                           display-input
                           float></nxt-core-input-number>
  </div>
</template>

<style scoped lang="scss">
.#{$prefixName}additional-cost {
  display: initial;
}
</style>
